import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-receptionlist-client-view-page',
  templateUrl: './receptionlist-client-view-page.component.html',
  styleUrls: ['./receptionlist-client-view-page.component.css']
})
export class ReceptionlistClientViewPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
